import { render, staticRenderFns } from "./ChartProjects.vue?vue&type=template&id=242dced6&"
import script from "./ChartProjects.vue?vue&type=script&lang=js&"
export * from "./ChartProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports